import React from "react";
import "./RuleList.scss";
import GridDuck from "gridduck";
import RuleCard from "../components/RuleCard/RuleCard";
import {StandardListCell, List, TickListCell, Icon} from "gd-react";
import history from "../meta/history";
import NoItems from "../components/noItems";
import AddAutomationModal from "../modals/Automation/AddAutomationModal";

class AlertListPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.getList = this.getList.bind(this);
        this.goToRule = this.goToRule.bind(this);
    }

    goToRule(rule) {
        history.push("/alerts/" + rule.id);
        this.setState({showAutomationModal: rule});
    }

    componentDidMount() {
        let self = this;
        let alertId = self.props.match.params.alertId;
        if (alertId) {
            GridDuck.getRule({id: alertId}).then((rule) => {
                self.setState({showAutomationModal: rule})
            })
        }
    }

    getList(retrievalParams) {
        return GridDuck.getRules(retrievalParams);
    }

    render() {

        return (
            <div className={"page white"}>
                <List
                    noitemelem={<NoItems text={'You haven\'t created any alerts yet'} createtext={'Create Alert'}
                                         onclickfunc={() => this.setState({createAlert: true})}/>}
                    columns={[
                        {
                            component: StandardListCell,
                            bold: true,
                            title: 'Name',
                            field: 'name',
                            sortable: true,
                            defaultSort: 'asc'
                        },
                        {component: StandardListCell, title: 'Description', field: 'description', maxWidth: 'none'},
                        // {component: TickListCell, title: 'Active', field: 'active', maxWidth: '100px'}
                    ]}
                    getlist={this.getList}
                    filters={[
                        {
                            field: 'alerts',
                            value: true
                        }
                    ]}
                    rowOnClick={this.goToRule}/>
                {this.state.showAutomationModal || this.state.createAlert ? <AddAutomationModal type={'alert'} onClose={() => {
                    this.setState({showAutomationModal: null, createAlert: null});
                    history.push('/alerts');
                }} open={!!this.state.showAutomationModal || this.state.createAlert} item={this.state.showAutomationModal}/> : ''}
            </div>
        )
    }
}

export default AlertListPage;
